import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface TestimonialCardProps {
  text: string;
  author: string;
  delay: number;
}
function TestimonialCard({
  text,
  author,
  delay
}: TestimonialCardProps) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 30
  }} animate={inView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6,
    delay
  }} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-2xl transition-shadow" data-id="element-205">
      <div className="flex gap-1 mb-4 justify-center" data-id="element-206">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#d97706] text-[#d97706]" data-id="element-207" />)}
      </div>
      <p className="text-gray-700 italic mb-6 leading-relaxed text-center" data-id="element-208">
        "{text}"
      </p>
      <p className="text-[#1a365d] font-semibold text-center" data-id="element-209">— {author}</p>
    </motion.div>;
}
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const testimonials = [{
    text: t('Jesús me ayudó a encontrar un plan de salud que se ajustaba perfectamente a mi presupuesto. Su paciencia y dedicación hicieron toda la diferencia.', 'Jesús helped me find a health plan that perfectly fit my budget. His patience and dedication made all the difference.'),
    author: 'María G.'
  }, {
    text: t('Gracias a Jesús, mi madre pudo entender sus opciones de Medicare sin estrés. Un profesional con corazón.', 'Thanks to Jesús, my mother was able to understand her Medicare options without stress. A professional with heart.'),
    author: 'Carlos R.'
  }, {
    text: t('Contraté mi seguro de vida con la asesoría de Jesús y me siento tranquilo sabiendo que mi familia está protegida.', "I got my life insurance with Jesús's guidance and I feel at peace knowing my family is protected."),
    author: 'Roberto M.'
  }];
  return <section id="testimonios" className="py-20 bg-gray-50" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-212">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a365d] mb-4" data-id="element-213">
            {t('Lo Que Dicen Nuestros Clientes', 'What Our Clients Say')}
          </h2>
          <div className="w-24 h-1 bg-[#d97706] mx-auto" data-id="element-214"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-215">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} delay={0.2 + index * 0.1} data-id="element-216" />)}
        </div>
      </div>
    </section>;
}